var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphonesActive = function SvgHeadphonesActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.815 5.815A7.333 7.333 0 0 1 18.333 11v.917H16.5a2.75 2.75 0 0 0-2.75 2.75v2.75a2.75 2.75 0 0 0 2.75 2.75h.917a2.75 2.75 0 0 0 2.75-2.75V11a9.167 9.167 0 0 0-18.334 0v6.417a2.75 2.75 0 0 0 2.75 2.75H5.5a2.75 2.75 0 0 0 2.75-2.75v-2.75a2.75 2.75 0 0 0-2.75-2.75H3.667V11c0-1.945.772-3.81 2.148-5.185Z"
  })));
};
export default SvgHeadphonesActive;